// extracted by mini-css-extract-plugin
export var baseButton = "_w3-0";
export var controlsArrowKeys = "_w3-1";
export var controlsResetButton = "_w3-2";
export var lightGameButton = "_w3-4 _w3-0";
export var playAgainButton = "_w3-5 _w3-0";
export var startGameButton = "_w3-3 _w3-0";